import { createFileRoute } from '@tanstack/react-router';
import { AIChatPage } from '@/features/ai-chat/AIChatPage';

export const Route = createFileRoute('/app/ai-chat')({
  component: AIChatPage,
});
